import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import Gallery from "./Gallery";
import GalleryLogin from "./GalleryLogin";
import styles from "./photos.module.css";

const Photos: React.FC = () => {
  const { loading, isGuest, isAdmin } = useAuth();

  return (
    <>
      <section className="container">
        <div className="pageTitle">Photos</div>
        <div className={`blurb ${styles.thanks}`}>
          <p>
            Thank you for making these memories with us. Our wedding day was everything
            we hoped for, and that's because of all of you who travelled, celebrated,
            danced and shared it with us. These photos are as much yours as they are ours,
            so please download your favorites.
          </p>
          <p>
            One small request: we've already printed the photos we want to keep, so please
            don't feel you need to turn any of these into gifts for us. No prints, frames,
            canvases, mugs or photo books needed. Having you there was the gift.
          </p>
        </div>
      </section>

      <section className={styles.gallerySection}>
        {loading ? (
          <p className={styles.status}>Loading...</p>
        ) : isGuest || isAdmin ? (
          <Gallery />
        ) : (
          <GalleryLogin />
        )}
      </section>
    </>
  );
};

export default Photos;
